
import Vue from "vue";
import { Component } from "vue-property-decorator";
import S404 from "@/views/404.vue";
import Markdown from "@/components/Markdown.vue";
import activities, { Activity } from "@/store/activity";

@Component({
  components: { Markdown, S404 },
})
export default class ActivityDetail extends Vue {
  name = "ActivityDetail";

  get activity(): Activity | undefined {
    return activities.find((v) => this.$en(v.name) === this.$route.params.name);
  }
}
